<template>
    <!--begin::Navbar-->
    <div class="card mb-5 mb-xl-10">
        <div class="card-body pt-9 pb-0">
            <!--begin::Details-->
            <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
                <!--begin: Pic-->
                <div class="me-7 mb-4">
                    <div class="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                        <img src="/media/avatars/blank.png" alt="image"/>
                        <div class="position-absolute translate-middle bottom-0 start-93_5 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px"></div>
                    </div>
                </div>
                <!--end::Pic-->

                <!--begin::Info-->
                <div class="flex-grow-1">
                    <!--begin::Title-->
                    <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                        <!--begin::User-->
                        <div class="d-flex flex-column">
                            <!--begin::Name-->
                            <div class="d-flex align-items-center mb-2">
                                <a class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1"> {{ $root.currentUser.firstname + ' ' + $root.currentUser.lastname }}</a>
                                <a>
                                    <span class="svg-icon svg-icon-1 svg-icon-primary svg-verified">
                                        <inline-svg src="/media/icons/duotune/general/gen026.svg"/>
                                    </span>
                                </a>
                                <!--<a href="#" class="btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3" data-bs-toggle="modal" data-bs-target="#kt_modal_upgrade_plan">Upgrade to Pro</a>-->
                            </div>
                            <!--end::Name-->

                            <!--begin::Info-->
                            <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                <a :href="'mailto:'+ $root.currentUser.email" class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="/media/icons/duotune/communication/com011.svg"/>
                                    </span>
                                    {{ $root.currentUser.email }}
                                </a>
                            </div>
                            <!--end::Info-->

                            <!--begin::Info-->
                            <div class="fw-bold fs-6 mb-4 pe-2">
                                <ul class="company-list">
                                    <template v-for="(company, index) in companies" :key="company.id || index">
                                        <li class="badge" :class="companyColors[index]">{{ company.name }}</li>
                                    </template>
                                </ul>
                            </div>
                            <!--end::Info-->
                        </div>
                        <!--end::User-->


                    </div>
                    <!--end::Title-->
                </div>
                <!--end::Info-->
            </div>
            <!--end::Details-->

            <!--begin::Navs-->
            <div class="d-flex overflow-auto h-55px">
                <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">
                    <!--begin::Nav item-->
                    <li class="nav-item">
                        <router-link to="/account/overview" class="nav-link text-active-primary me-6" active-class="active">
                            {{ $t('common.overview') }}
                        </router-link>
                    </li>
                    <!--end::Nav item-->
                    <!--begin::Nav item-->
                    <li class="nav-item">
                        <router-link to="/account/settings" class="nav-link text-active-primary me-6" active-class="active">
                            {{ $t('common.settings') }}
                        </router-link>
                    </li>
                    <!--end::Nav item-->
                </ul>
            </div>
            <!--begin::Navs-->
        </div>
    </div>
    <!--end::Navbar-->
    <router-view></router-view>
</template>

<script>
export default {
    name: "account",
    data() {
        return {
            companyColors: []
        }
    },
    computed: {
        companies() {
            return this.$store.state.company.authorized.table.data
        },
    },
    mounted() {
        this.$store.dispatch('company/authorized/get', {
            page: {pageSize: 9999}
        })
    },
    methods: {
        assignRandomColors(count) {
            const colors = [
                "badge-light-primary",
                "badge-light-warning",
                "badge-light-success",
                "badge-light-danger",
                "badge-primary",
                "badge-warning",
                "badge-success",
                "badge-danger"
            ];

            const result = [];
            let availableColors = [...colors];

            for (let i = 0; i < count; i++) {
                if (availableColors.length === 0) {
                    availableColors = [...colors];
                }

                const randomIndex = Math.floor(Math.random() * availableColors.length);
                result.push(availableColors[randomIndex]);

                availableColors.splice(randomIndex, 1);
            }

            return result;
        }
    },
    watch: {
        companies(newCompanies) {
            if (newCompanies.length > 0 && this.companyColors.length === 0) {
                this.companyColors = this.assignRandomColors(newCompanies.length);
            }
        }
    }
}
</script>

<style>
ul.company-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

ul.company-list li {
    margin-right: 10px;
}
</style>